export default "__VITE_ASSET__DtBi51kn__"